import { render, staticRenderFns } from "./SolicitacaoDetalhe.vue?vue&type=template&id=83689d76"
import script from "./SolicitacaoDetalhe.vue?vue&type=script&lang=js"
export * from "./SolicitacaoDetalhe.vue?vue&type=script&lang=js"
import style0 from "./SolicitacaoDetalhe.vue?vue&type=style&index=0&id=83689d76&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports